document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.nav-toggle');
    if (toggle) {
      var nav = document.querySelector('.site-nav');
      if (!nav) return;
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Menü öffnen' : 'Menü schließen');
      nav.classList.toggle('is-open', !isOpen);
      document.body.classList.toggle('nav-open', !isOpen);
      return;
    }
    var navLink = event.target.closest('.site-nav a');
    if (navLink) {
      var openToggle = document.querySelector('.nav-toggle');
      var openNav = navLink.closest('.site-nav');
      if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
      if (openNav) openNav.classList.remove('is-open');
      document.body.classList.remove('nav-open');
    }
  });

  document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach(function (button) {
    button.addEventListener('click', function () {
      var control = button.closest('.quantity-control');
      var input = control && control.querySelector('input');
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      input.value = String(button.hasAttribute('data-quantity-plus') ? value + 1 : Math.max(0, value - 1));
      if (input.hasAttribute('data-cart-quantity')) input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('.product-gallery');
      var image = gallery && gallery.querySelector('#product-main-image');
      if (!image) return;
      image.src = thumb.getAttribute('data-image-src');
      image.alt = thumb.getAttribute('data-image-alt') || image.alt;
      gallery.querySelectorAll('.product-gallery__thumb').forEach(function (item) { item.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  var productForm = document.querySelector('[data-product-form]');
  var variantData = document.querySelector('[data-variants]');
  if (productForm && variantData) {
    var variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (error) { variants = []; }
    var selects = productForm.querySelectorAll('[data-option-position]');
    var idInput = productForm.querySelector('[name="id"]');
    var submit = productForm.querySelector('[type="submit"]');
    var updateVariant = function () {
      var selected = [];
      selects.forEach(function (select) { selected.push(select.value); });
      var match = variants.find(function (variant) {
        return variant.available && selected.every(function (value, index) { return variant['option' + (index + 1)] === value; });
      });
      if (match) { idInput.value = match.id; if (submit) { submit.disabled = false; submit.textContent = 'In den Warenkorb'; } }
      else { idInput.value = ''; if (submit) { submit.disabled = true; submit.textContent = 'Ausverkauft'; } }
    };
    selects.forEach(function (select) { select.addEventListener('change', updateVariant); });
    updateVariant();
  }

  document.querySelectorAll('[data-cart-quantity]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
});
